import { badgeByTab } from "~/feature/categories/components/Categories/constants";
import { EventTagEnum } from "~/types/tag";

export const renderBadge = (tab: string) => {
  const badge = badgeByTab[tab as EventTagEnum];
  if (!badge) return null;
  const BadgeIcon = badge;
  return <BadgeIcon fontSize="inherit" />;
};
